import { Product } from '../../domain/product/Product'

class Keys {
  static TOKEN: string = 'token'
  static IMPERSONATOR_TOKEN: string = 'impersonator-token'
  static SEARCHED_COMPANY_ID: string = 'searched-company-id'
  static SEARCHED_COMPANY_NAME: string = 'searched-company-name'
  static PLAN_CODE: string = 'plan-code'
  static SUBSCRIPTION_PACKAGE_CODE: string = 'default-package'
  static PROSPECT_SIGNUP_CODE: string = 'prospect-signup-code'
  static DISMISSED_RENEWAL_NOTIFICATION: string = 'dismissed-renewal-notification'
  static LAST_PRODUCT_ID: string = 'last-product-id'
  static TEMPORARY_EMAIL: string = 'temporary-email'

  constructor() {}
}

export const sessionStore = {
  set: (key: string, value: string) => {
    sessionStorage.setItem(key, value)
  },

  get: (key: string): string | null => {
    return sessionStorage.getItem(key)
  },

  setSessionToken: (token: string) => {
    sessionStorage.setItem(Keys.TOKEN, token)
  },

  getSessionToken: (): string | null => sessionStorage.getItem(Keys.TOKEN),
}

export const localStore = {
  set: (key: string, value: string) => {
    localStorage.setItem(key, value)
  },

  get: (key: string): string | null => {
    return localStorage.getItem(key)
  },
}

export const store = sessionStore.getSessionToken() ? sessionStore : localStore

export default {
  setToken: (token: string) => {
    store.set(Keys.TOKEN, token)
  },
  getToken: (): string | null => store.get(Keys.TOKEN),

  setImpersonatorToken: (token: string) => {
    store.set(Keys.IMPERSONATOR_TOKEN, token)
  },
  getImpersonatorToken: (): string | null => store.get(Keys.IMPERSONATOR_TOKEN),

  setSearchedCompanyId: (id: string) => {
    store.set(Keys.SEARCHED_COMPANY_ID, id)
  },
  getSearchedCompanyId: (): string | null => store.get(Keys.SEARCHED_COMPANY_ID),

  setSearchedCompanyName: (name: string) => {
    store.set(Keys.SEARCHED_COMPANY_NAME, name)
  },
  getSearchedCompanyName: (): string | null => store.get(Keys.SEARCHED_COMPANY_NAME),

  setPlanCode: (name: string) => {
    store.set(Keys.PLAN_CODE, name)
  },
  getPlanCode: (): string | null => store.get(Keys.PLAN_CODE),

  setSubscriptionPackageCode: (name: string) => {
    store.set(Keys.SUBSCRIPTION_PACKAGE_CODE, name)
  },
  getSubscriptionPackageCode: (): string | null => store.get(Keys.SUBSCRIPTION_PACKAGE_CODE),
  setProspectSignupCode: (code: string) => {
    store.set(Keys.PROSPECT_SIGNUP_CODE, code)
  },
  getProspectSignupCode: (): string | null => store.get(Keys.PROSPECT_SIGNUP_CODE),
  setDismissedRenewalNotification: (dismissed: boolean) => {
    store.set(Keys.DISMISSED_RENEWAL_NOTIFICATION, dismissed ? 'dismissed' : '')
  },
  getDismissedRenewalNotification: (): string | null => store.get(Keys.DISMISSED_RENEWAL_NOTIFICATION),
  setLastProductId: (productId: number) => {
    store.set(Keys.LAST_PRODUCT_ID, productId.toString())
  },
  getLastProductId: (): number => {
    const value = store.get(Keys.LAST_PRODUCT_ID)
    return value !== null ? parseInt(value) : Product.GroupHraId
  },
  setTemporaryEmail: (email: string) => {
    store.set(Keys.TEMPORARY_EMAIL, email)
  },
  getTemporaryEmail: (): string | null => {
    return store.get(Keys.TEMPORARY_EMAIL)
  },
}
